import { Component, Input } from '@angular/core';
import { QRButton } from '@base/src/app/models/qr-button.model';

@Component({
  selector: 'qr-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent {
  @Input() name?: string;
  @Input() color!: string;
  @Input() size?: number = QRButton.SIZE_MEDIUM; // Si queremos icono mas chico para el qrbutton icon only
  @Input() small?: boolean;
}
